import { useState } from 'react';
import { NavTitle } from '../UI/StyledComponents/NavigationStyledComponents';
import { Box, List, ListItem, Typography } from '@mui/material';
import { NavLink, useLocation } from 'react-router-dom';
import useTranslate from '../../hooks/useTranslate';
import Icon from '../../assets/icons/icons';
import {
  CenteredFullBackDrop,
  InlineContainer,
} from '../../styled-components/GlobalStyledComponents';
import Modal from '../UI/Popup/BackdropComponent';
import { CenteredFullOverlay } from '../UI/StyledComponents/NotificationModalStyledComponents';
import CloseButton from '../SharedComponents/CloseButton';
import LoadHelpContent from './LoadHelpContent';
import useDetectResize from '../../hooks/useDetectResize';
import TranslationComponent from '../../translation/TranslationComponent';

const MobileNavListComponent = (props: { onToggleSelectNagivation: () => void }) => {
  //const { hideMenu } = props;
  let activeNavBtn = 'active-nav';
  let navBtn = 'inactive-nav';

  const { browserWindow } = useDetectResize();
  const location = useLocation();

  const [showHelpModal, setShowHelpModal] = useState<boolean>(false);

  const t = useTranslate();
  const listItem = { width: '225px' };
  const imgStyling = { width: '13vw', maxWidth: '35px', height: 'auto' };
  const navListStyling = {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    paddingLeft: '0px',
  };
  return (
    <>
      <List
        sx={{
          flex: 1,
          display: 'inline-grid',
          height: 'fit-content',
          justifyContent: 'center',
          gridTemplateRows: 'repeat(6, max-content) 40%',
          '@media (max-resolution: 1dppx) and (min-height: 1030px)': {
            paddingTop: '1.9rem',
          },
        }}
      >
        <ListItem sx={listItem}>
          <NavLink
            to="/dashboard"
            className={(props: { isActive: boolean }) => (props.isActive ? activeNavBtn : navBtn)}
            onClick={props.onToggleSelectNagivation}
          >
            <InlineContainer sx={navListStyling}>
              <img style={imgStyling} src={Icon.Dashboard} alt="dash" loading="lazy" />
              <NavTitle variant="h3">{t('dashboardNav')}</NavTitle>
            </InlineContainer>
          </NavLink>
        </ListItem>

        <ListItem sx={listItem}>
          <NavLink
            to="/profile"
            className={(props: { isActive: boolean }) => (props.isActive ? activeNavBtn : navBtn)}
            onClick={props.onToggleSelectNagivation}
          >
            <InlineContainer sx={navListStyling}>
              <img style={imgStyling} src={Icon.Profile} alt="prof" loading="lazy" />
              <NavTitle variant="h3">{t('mobileNav-myProfile')}</NavTitle>
            </InlineContainer>
          </NavLink>
        </ListItem>

        <ListItem sx={listItem}>
          <NavLink
            to="/jobs"
            className={(props: { isActive: boolean }) => (props.isActive ? activeNavBtn : navBtn)}
            onClick={props.onToggleSelectNagivation}
          >
            <InlineContainer sx={navListStyling}>
              <img style={imgStyling} src={Icon.Jobs} alt="jobs" loading="lazy" />
              <NavTitle variant="h3">{t('jobNav')}</NavTitle>
            </InlineContainer>
          </NavLink>
        </ListItem>

        <ListItem sx={listItem}>
          <NavLink
            to="/myjobmatches"
            className={(props: { isActive: boolean }) => (props.isActive ? activeNavBtn : navBtn)}
            onClick={props.onToggleSelectNagivation}
          >
            <InlineContainer sx={navListStyling}>
              <img style={imgStyling} src={Icon.MyJobMatches} alt="mjm" loading="lazy" />
              <NavTitle variant="h3">{t('mobileNav-myJobMatches')}</NavTitle>
            </InlineContainer>
          </NavLink>
        </ListItem>

        <ListItem sx={listItem}>
          <NavLink
            to="/activity"
            className={(props: { isActive: boolean }) => (props.isActive ? activeNavBtn : navBtn)}
            onClick={props.onToggleSelectNagivation}
          >
            <InlineContainer sx={navListStyling}>
              <img style={imgStyling} src={Icon.MyActivity} alt="mjm" loading="lazy" />
              <NavTitle variant="h3">{t('mobileNav-myActivity')}</NavTitle>
            </InlineContainer>
          </NavLink>
        </ListItem>

        <ListItem sx={listItem}>
          <NavLink
            to="/chat"
            className={(props: { isActive: boolean }) => (props.isActive ? activeNavBtn : navBtn)}
            onClick={props.onToggleSelectNagivation}
          >
            <InlineContainer sx={navListStyling}>
              <img style={imgStyling} src={Icon.ChatIcon} alt="mjm" loading="lazy" />
              <NavTitle variant="h3">Chat</NavTitle>
            </InlineContainer>
          </NavLink>
        </ListItem>

        <ListItem sx={listItem}>
          <Box
            className={navBtn}
            onClick={(e) => {
              setShowHelpModal(true);
              e.stopPropagation();
            }}
          >
            <InlineContainer sx={navListStyling}>
              <img style={imgStyling} src={Icon.Help} alt="mjm" loading="lazy" />
              <NavTitle variant="h3">{t('mobileNav-help')}</NavTitle>
            </InlineContainer>
          </Box>
        </ListItem>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'end',
          }}
        >
          <TranslationComponent />
        </Box>
      </List>
      {showHelpModal && (
        <Modal className="help-popup" onHide={() => {}}>
          <CenteredFullOverlay
            className={location.pathname.slice(1)}
            top={browserWindow.h}
            right={browserWindow.w}
            onClick={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
              e.stopPropagation();
            }}
          >
            <CenteredFullBackDrop>
              <InlineContainer
                justifyContent="space-between"
                alignItems="flex-end"
                sx={{ '& > div.close-button': { marginBottom: '20px' } }}
              >
                <Typography variant="h1" paddingLeft="0.5em">
                  {t('help')}
                </Typography>
                <CloseButton
                  onHide={() => {
                    setShowHelpModal(false);
                  }}
                />
              </InlineContainer>
              <Box>
                <LoadHelpContent />
              </Box>
            </CenteredFullBackDrop>
          </CenteredFullOverlay>
        </Modal>
      )}
    </>
  );
};

export default MobileNavListComponent;
